import axios from 'axios';
import toastr from 'toastr';
import twofactorexplanation from './twofactorexplanation.vue';
import { AUTH_SUCCESS_TWOFACTOR_UPDATE } from '../../../store/actions/authactions';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'TwoFactor',
    props: {
        id: {
            type: Number
        }
    },
    data() {
        return {
            initialized: false,
            record: {
                imageUrl: '',
                isTwoFactor: false,
                code: '',
                isSecretKey: false
            },
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {

    },
    methods: {
        fetch() {
            let fetchAction = axios.get(APIURL + '/applicationuser/two-factor/' + this.id)
                .then(resp => {
                    this.initialized = true;
                    this.record = resp.data;
                });
        },
        dismiss() {
            this.$vuedals.dismiss();
        },
        saveChanges() {
            if (this.record.code == '' || this.record.code == null)
                toastr.error(this.$t('error.twofactorcode'), '');
            else {
                let saveAction = axios.post(APIURL + '/applicationuser/two-factor-verify/' + this.id, this.record);
                saveAction.then(resp => {
                    if (resp.data) {
                        this.twoFactorUpdate(true);
                        toastr.success(this.$t('success.saveChanges'), '');
                        this.$vuedals.close();
                    }
                    else {
                        toastr.error(this.$t('error.invalid_code'), '');
                    }
                    //this.record = resp.data;
                });
            }
            //this.twoFactorUpdate(true);
            
        },
        showTotpHelp() {
            this.$vuedals.open({
                title: this.$t('totpexplanation'),                
                component: twofactorexplanation,
                size: 'lg',
                escapable: true,
            });
        },
        ...mapActions('auth', {
            twoFactorUpdate: AUTH_SUCCESS_TWOFACTOR_UPDATE,
        }),
    }
};